export function loadHandTalk(token) {
	const scriptHandTalk = document.createElement('script')

	scriptHandTalk.type = 'text/javascript'
	scriptHandTalk.src = 'https://plugin.handtalk.me/web/latest/handtalk.min.js'
	scriptHandTalk.async = true

	scriptHandTalk.onload = () => {
		if (typeof HT !== 'undefined') {
			new HT({
				token: token
			})
		}
	}

	scriptHandTalk.onerror = () => {
		console.error('Error loading HandTalk script')
	}

	const currentUrl = window.location.pathname
	const shouldLoadHandTalk = !currentUrl.includes('muviflex-iframe')

	if (shouldLoadHandTalk) {
		document.body.appendChild(scriptHandTalk)
	}
}

export default loadHandTalk
